module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAAAJCAYAAAAMyKFDAAAAsklEQVRoQ+3TwQnCQBCF4ZkOkrAWZjE5aAnajH0tCVuAsuJByEFEL5M38G8DO/y8z41HAQqkLeAZLq9rmw/TcM1wKzdSILKAPOC6tG5mD3M7gThyGvyVoYA04Bde7/1YynirS7uDOMOkuDGygCzgLd53EBBHToO/MhSQBPwJL4gzzIkbowvIAf6Gd4vY3c5lGi7RwfiPAkoFpAD/ghfESvPhlr0LyAD+By+I954N/6sUeAIsllIKh7MUQgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about-c_line.png
// module id = ULjf
// module chunks = 1